// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const FingerprintIcon = /* @__PURE__ */ createIcon(
  'fingerprint',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M14.71 16.806a1 1 0 0 1 1.923.545 23 23 0 0 1-1.56 4.02 1 1 0 0 1-1.788-.897 21 21 0 0 0 1.424-3.668m-3.21-5.728a1 1 0 1 1 2 0 18.9 18.9 0 0 1-2.906 10.104A1 1 0 0 1 8.9 20.117a16.9 16.9 0 0 0 2.6-9.039m8 0A7 7 0 0 0 9.001 5.014 1 1 0 0 1 8 3.284a9 9 0 0 1 13.5 7.794 27 27 0 0 1-1.028 7.404 1 1 0 0 1-1.924-.547c.62-2.178.952-4.478.952-6.858m-16 0c0-1.638.439-3.176 1.205-4.5a1 1 0 0 1 1.73 1.001 6.96 6.96 0 0 0-.935 3.5c0 1.718-.395 3.348-1.1 4.8a1 1 0 1 1-1.8-.874 8.96 8.96 0 0 0 .9-3.927m12 0a3 3 0 0 0-6 0 14.9 14.9 0 0 1-2.333 8.041 1 1 0 0 1-1.72-1.021l.068-.11a12.9 12.9 0 0 0 1.985-6.91 5 5 0 0 1 10 0q-.002 1.596-.213 3.136a1 1 0 1 1-1.981-.272q.193-1.405.194-2.864',
      },
    ],
  ]
);
